module.exports = __webpack_public_path__ + "static/media/44474654_2199896123418900_4197121502841143296_o-thumb.140bd788.jpg";